import PropTypes from 'prop-types';

import { profileShape } from 'propTypes/profile';

export const profileReviewsPropTypes = {
  profile: profileShape.isRequired,
  query: PropTypes.shape({
    page: PropTypes.number.isRequired,
    widget: PropTypes.string,
  }).isRequired,
};
